const Machine: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 1.90625H3C1.89543 1.90625 1 2.80168 1 3.90625V21.9062C1 23.0108 1.89543 23.9062 3 23.9062H18C19.1046 23.9062 20 23.0108 20 21.9062V3.90625C20 2.80168 19.1046 1.90625 18 1.90625Z"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16 6.90625H5V10.9062H16V6.90625Z"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5 14.9062H6"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10 14.9062H11"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5 18.9062H6"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10 18.9062H11"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15 14.9062H16"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15 18.9062H16"
        stroke="#31383F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default Machine;
